import React, { Component } from "react";
import { CountWidget } from "../../../Component/CountWidget";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';

import SidebarObject from "../../../Component/SidebarObject";

import { NewObjectButtonContainer } from "../../../Component/ObjectListAndDetail";

import "./Style.css";

class SubjectLandingComponent extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            newObjectModalIsOpen: false,
            editObjectModalIsOpen: false,
            routeToNewObject: undefined,
            updateComponent: 0
        };

        this.openEditObjectModal = this.openEditObjectModal.bind(this);
        this.closeEditObjectModal = this.closeEditObjectModal.bind(this);
    }

    openObject() {}

    openEditObjectModal(editObject: any) {
        this.setState({
            editObjectModalIsOpen: true,
            editObject: editObject
        });
    }

    closeEditObjectModal() {
        this.setState({
            editObjectModalIsOpen: false
        });
    }

    render() {
        const { isLoggedIn, subject, removeSubjectObject } = this.props;

        return (
            <Grid container direction="row" className="SubjectLanding">
                <Grid item xs={"auto"} sm={3} md={2}>
                    <SidebarObject
                        location={this.props.location}
                        subjectHashKey={subject.hash_key}
                        hasCreateAccess={isLoggedIn}
                        subject={subject}
                        subject_user={subject.user}
                        subject_slug={subject.slug}
                    />
                </Grid>
                <Grid item xs={12} sm={9} md={10}>
                    <Paper square className="SubjectLandingContent">
                        <div className="container">
                            <h1>{subject.title}</h1>
                            <p className="large">{subject.description}</p>
                            <div>
                                {" "}
                                <CountWidget
                                    count={subject.objects.size}
                                    singular_text="Card"
                                />
                            </div>
                            <img
                                className="title-image"
                                style={{ width: "60%" }}
                                src={subject.image_url}
                            />
                            <p>{subject.landing_detail_raw_markdown}</p>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        );
    }
}

export { SubjectLandingComponent };
